var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { UserRole } from '@/share/InternalUserStat';
import { Box, Button, Icon, Menu, MenuButton, MenuItem, MenuList, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Text } from '@chakra-ui/react';
import { action, makeObservable, observable } from 'mobx';
import { observer } from 'mobx-react';
import React from 'react';
import { MdMenu } from '@react-icons/all-files/md/MdMenu';
export class UserRolePickerState {
    constructor() {
        this.open = false;
        this.okcb = (pin) => console.log("absorb");
        this.selop = undefined;
        this.openmenu = false;
        makeObservable(this);
    }
    setOpen(open) {
        this.open = open;
        if (!open) {
            this.setUserRole(undefined);
        }
    }
    setUserRole(role) {
        this.selop = role;
    }
    setOpenActionMenu(open) {
        this.openmenu = open;
    }
    setOKCb(cb) {
        this.okcb = cb;
    }
}
__decorate([
    observable,
    __metadata("design:type", Object)
], UserRolePickerState.prototype, "open", void 0);
__decorate([
    observable,
    __metadata("design:type", String)
], UserRolePickerState.prototype, "selop", void 0);
__decorate([
    observable,
    __metadata("design:type", Object)
], UserRolePickerState.prototype, "openmenu", void 0);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserRolePickerState.prototype, "setOpen", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [String]),
    __metadata("design:returntype", void 0)
], UserRolePickerState.prototype, "setUserRole", null);
__decorate([
    action,
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Boolean]),
    __metadata("design:returntype", void 0)
], UserRolePickerState.prototype, "setOpenActionMenu", null);
let RolePickerDialog = class RolePickerDialog extends React.Component {
    constructor(prop) {
        super(prop);
    }
    apply() {
        if (this.props.rolestate.selop !== undefined) {
            this.props.rolestate.okcb(this.props.rolestate.selop);
        }
        this.props.rolestate.setOpen(false);
    }
    render() {
        return (React.createElement(Modal, { isOpen: this.props.rolestate.open, onClose: () => console.log("absorb") },
            React.createElement(ModalOverlay, null),
            React.createElement(ModalContent, null,
                React.createElement(ModalHeader, null, "Role"),
                React.createElement(ModalBody, { minH: '140px' },
                    React.createElement(Box, { ml: '15px' },
                        this.props.rolestate.selop !== undefined &&
                            React.createElement(Text, { mb: '20px', fontWeight: 'bold', fontSize: '20px' }, "Selected: " + this.props.rolestate.selop),
                        React.createElement(Menu, { isLazy: true, isOpen: this.props.rolestate.openmenu, closeOnSelect: true, onClose: () => this.props.rolestate.setOpenActionMenu(false) },
                            React.createElement(MenuButton, { onClick: () => this.props.rolestate.setOpenActionMenu(!this.props.rolestate.openmenu), as: Button, rightIcon: React.createElement(Icon, { as: MdMenu }) }, "Select Role"),
                            this.props.rolestate.openmenu && React.createElement(MenuList, null,
                                React.createElement(MenuItem, { onClick: () => this.props.rolestate.setUserRole(UserRole.Admin) }, UserRole.Admin),
                                React.createElement(MenuItem, { onClick: () => this.props.rolestate.setUserRole(UserRole.User) }, UserRole.User))))),
                React.createElement(ModalFooter, null,
                    React.createElement(Button, { colorScheme: "red", mr: 3, onClick: () => this.props.rolestate.setOpen(false) }, "Cancel"),
                    React.createElement(Box, { width: '60px' },
                        React.createElement(Button, { disabled: this.props.rolestate.selop === undefined, onClick: () => this.apply(), colorScheme: "blue" }, "Apply"))))));
    }
};
RolePickerDialog = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], RolePickerDialog);
export { RolePickerDialog };
